import { useCallback } from 'react';
import { useGetLibraryItemTypesQuery } from '@casops/store/apis/settingsApi';
import { ValueGetterFunc, ValueGetterParams } from 'ag-grid-community';
import { EmptyCell } from '../../formatters/genericFormatters';

export const useLibraryItemNameValueGetter = <TData extends { ty: number }>(): ValueGetterFunc<
  TData,
  string
> => {
  const { data: libraryItemTypes } = useGetLibraryItemTypesQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  // Return the name as the cell value (for sorting and searching to work).
  const valueGetter = useCallback(
    ({ data }: ValueGetterParams<TData, string>): string => {
      let name: string | undefined;

      // Attempt to get the name of a matching library item.
      if (data && typeof data.ty === 'number' && libraryItemTypes) {
        name = libraryItemTypes.find(({ id }) => id === data.ty)?.n;
      }

      return name ?? EmptyCell;
    },
    [libraryItemTypes],
  );

  return valueGetter;
};
